import React, { useRef, useState } from "react";
import MediaIcon from "../../icons/MediaIcon";
import TextButton from "../Button/TextButton/TextButton";
import Select from 'react-select';
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser } from "../../store/user/userSelector";
import { postTheTweet } from "../../services/tweetService";
import { POSTING_TWEET_FAILED, POSTING_TWEET_FINISED, POSTING_TWEET_STARTED } from "../../store/user/userSlice";
import cogoToast from 'cogo-toast';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

export default function SendTweet({ className, placeholder, tweet = null }) {
  const dispatch = useDispatch()
  const state = useSelector((state) => state);
  const titleInput = useRef(null);
  const descriptionInput = useRef(null);
  const topicCategories = [
    { label: 'المجلس الاتحادي', value: 1 },
    { label: 'الولاية', value: 2 },
    { label: 'المحلية', value: 3 }
  ];
  const topicSubCategories = [
    { label: 'مشروع قرار تشريعي', value: 1 },
    { label: 'مشروع قرار مسائلة', value: 2 },
    { label: 'مشروع توصية', value: 3 }
  ];
  const postingTweet = useSelector(state => state.user.isPostingTweet)
  const currentUser = selectCurrentUser(state);
  const [topic, setTopic] = useState({
    title: '',
    description: '',
    topic_assets: [],
    topic_category_id: null,
    topic_sub_category_id: null
  });
  const [showEmojiBox, setShowEmojiBox] = useState(false);

  const getBase = async (file) => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        }
      } catch (error) {
        reject(error);
      }

    })
  }
  const sendTweetClassnames = classNames("send-tweet", className);

  function auto_grow(element) {
    element.target.style.height = "48px";
    element.target.style.height = element.target.scrollHeight + "px";
  }
  const handelTopicPicsChange = async (e) => {
    let arr = [];
    const files = e.target.files;
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxSize = 4 * 1024 * 1024; // 4 megabytes

    // Filter files based on type and size
    const filteredFiles = Array.from(files).filter(
      (file) => allowedTypes.includes(file.type) && file.size <= maxSize
    );
    for (const file of filteredFiles) {
      let ext = file.type.slice(file.type.indexOf('/') + 1);
      const data = await getBase(file);
      arr.push({
        asset_type: ext, asset_file: data
      })
    };
    setTopic({
      ...topic,
      topic_assets: [...arr]
    })
  }


  const removeTopicAsset = (index) => {
    let topic_copy = topic;
    topic_copy.topic_assets.splice(index, 1);
    setTopic({ ...topic_copy });

  }

  const handleDataChange = (field, value) => {
    setTopic({
      ...topic,
      [field]: value
    })
  }

  const handleSubmit = async () => {
    // if(type==='tweetReply')dispatch(postTweetReply(topic.title,tweetPic,tweet._id))
    // dispatch(postTweet(topic.title,tweetPic,tweet))
    try {
      // if(!caption) dispatch error
      dispatch(POSTING_TWEET_STARTED())
      topic.topic_category_id = topic.topic_category_id.value
      topic.topic_sub_category_id = topic.topic_sub_category_id.value
      if (!tweet) { await postTheTweet(topic); cogoToast.success('تم إضافة المشروع بنجاح 👍') }
      else {
        // const data = await postTheTweet(topic, tweet.id);
        // cogoToast.success('Added reply successfully 👍')
      }

      // dispatch success
      dispatch(POSTING_TWEET_FINISED())
      setTopic({
        title: '',
        description: '',
        topic_assets: [],
        topic_category_id: 1,
        topic_sub_category_id: 1
      });

      titleInput.current.style.height = "48px";
      descriptionInput.current.style.height = "88px";
    } catch (error) {
      dispatch(POSTING_TWEET_FAILED(error.message))
      cogoToast.error('حصل خطأ اثناء الاضافة الرجاء التأكد من المعلومات')
    }
  }

  return (
    <section className={sendTweetClassnames}>
      <div className={postingTweet ? "send-tweet-wrap disabled" : "send-tweet-wrap"} >
        <div className="wrapper">
          <div className="whats-happening">
            <div className="tweet-input-container">
              <textarea
                // onInput={(e) => auto_grow(e)}
                type="text"
                ref={titleInput}
                name="tweet-text"
                placeholder={placeholder || "عنوان المشروع"}
                className="tweet-input"
                maxLength={60}
                value={topic.title}
                onChange={(e) => { handleDataChange('title', e.target.value); auto_grow(e) }}
              />
            </div>
            <div className="tweet-input-container">
              <textarea
                // onInput={(e) => auto_grow(e)}
                type="text"
                ref={descriptionInput}
                name="tweet-text"
                placeholder={"تفاصيل المشروع"}
                className="tweet-input"
                maxLength={500}
                value={topic.description}
                onChange={(e) => { handleDataChange('description', e.target.value); auto_grow(e) }}
              />
            </div>

            <Select
              onChange={(e) => handleDataChange('topic_category_id', e)}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  backgroundColor: '#B9B4B4',
                  color: '#041259'
                }),
              }}
              placeholder='استهداف المشروع'
              className="basic-single my-4"
              classNamePrefix="select"
              value={topic.topic_category_id}
              isClearable={true}
              isRtl={true}
              isSearchable={true}
              name="color"
              options={topicCategories}
            />
            <Select
            onChange={(e) => handleDataChange('topic_sub_category_id', e)}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  backgroundColor: '#B9B4B4',
                  color: '#041259'
                }),
              }}
              placeholder='طبيعة المشروع'
              className="basic-single my-4"
              classNamePrefix="select"
              value={topic.topic_sub_category_id}
              isClearable={true}
              isRtl={true}
              isSearchable={true}
              name="color"
              options={topicSubCategories}
            />

            <input
              type="file"
              alt="tweet pic"
              id="tweetPic"
              name="tweetPic"
              hidden
              multiple={true}
              onChange={handelTopicPicsChange}
            ></input>
            <div className="tweet-pic-wrapper">
              {topic.topic_assets.length > 0 && topic.topic_assets.map((el, index) => <div key={index} className="tweet-pic">

                <span className="close-btn" onClick={() => removeTopicAsset(index)}>
                  <i className="fas fa-xmark"></i>
                </span>
                {el.asset_type == 'pdf' ? 
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                  <Viewer fileUrl={el.asset_file} />;
                </Worker>
                : <embed
                  src={el.asset_file}
                  alt="tweet-attachment"
                  className="tweet-attachment-pic"
                />}
                

              </div>
              )}
            </div>
            <p style={{color:"#fff"}}>يجب أن لا يتجاوز حجم الملف 4 ميغابايت,</p>
            <p style={{color:"#fff"}}>صيغة الملفات المسموح بها بي دي اف أو صور.</p>

            <div className="tweet-attachment">
              <div className="icon-containers">
                <div
                  onClick={() => document.getElementById("tweetPic").click()}
                  className={
                    topic.topic_assets.length > 0 ? "icon-container icon-disabled" : "icon-container"
                  }
                >
                  <MediaIcon
                    color={topic.topic_assets.length > 0 ? "red" : null}
                    className={topic.topic_assets.length > 0 && "disabled-icon"}

                  />
                </div>
                {/* <div className="icon-container icon-disabled">
                  <GifIcon className="disabled-icon" />
                </div>
                <div className="icon-container icon-disabled">
                  <PollIcon className="disabled-icon" />
                </div>
                <div className="icon-container">
                  <EmojiIcon
                    onClick={() => setShowEmojiBox((state) => !state)}
                  />
                </div>
                <div className="icon-container icon-disabled">
                  <ScheduleIcon className="disabled-icon" />
                </div>
                <div className="icon-container icon-disabled">
                  <LocationIcon className="disabled-icon" />
                </div> */}
              </div>
              <div className="send-tweet-btn-container">
                <TextButton bcBlue rounded className="send-tweet-btn" disabled={!topic.title || !topic.description || !topic.topic_category_id || !topic.topic_sub_category_id} onClick={handleSubmit}>
                  {tweet ? 'Reply' : 'إ ضافة'}
                </TextButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
